import styled from 'styled-components'
import { down, up } from 'styled-breakpoints'

export const FeaturesSectionContainer = styled.div<{ isRTL?: boolean; isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: ${(props) => (props.isMobile ? '18px 0px' : '40px 0px 0px 0px')};

  ${({ isRTL, isMobile }) => {
    if (isMobile) {
      if (isRTL) {
        return `padding-right: 15px;`
      } else {
        return `padding-left: 15px;`
      }
    }
    return ''
  }}
`

export const FeaturesSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1120px;
  width: 100%;
  margin: 0 auto;
`

export const FeatureItem = styled.div<{ isMobile: boolean }>`
  background-color: ${(props) => (props.isMobile ? '#fff' : '#f8f9fb')};
  display: flex;
  align-items: flex-start;
  padding: 16px 22.67px;
  border-radius: 8px;
  max-width: 352px;
  flex: 1;
  box-shadow: ${(props) => (props.isMobile ? '0 3px 3px rgba(0, 0, 0, 0.01), 0 0 8px rgba(0, 0, 0, 0.06)' : 'none')};

  ${down('md')} {
    height: 100%;
    max-width: 100%;
    flex-direction: row;
    gap: 16px;
  }
`

export const FeatureIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 8px;
  ${up('md')} {
    padding-right: 16px;
    padding-bottom: 0px;
  }
  [dir='rtl'] && {
    padding-right: 0px;
    padding-left: 16px;
    font-size: 16px;
  }

  ${down('md')} {
    padding-bottom: 0;
    min-width: 40px;
  }
`

export const FeatureContent = styled.div`
  display: flex;
  flex-direction: column;

  ${down('md')} {
    flex: 1;
  }
`

export const FeatureTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 19.07px;
  color: #131717;
  margin: 0px;
  padding: 0px 0px 4px 0px;
`

export const FeatureDescription = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  padding: 0px;
  margin: 0px;
`

export const PaymentLogosRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  margin-top: 8px;
`
